<template>
  <v-dialog persistent max-width="500" v-model="dialog">
    <v-card :disabled="loading">
      <v-toolbar dark flat color="red darken-1">
        <v-toolbar-title>Novo Papel</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-form ref="form" @submit.prevent="salvar()">
              <v-text-field
                v-model="form.nome"
                placeholder="Nome"
                prepend-icon="mdi-plus-circle"
                :rules="[rules.required]"
              />
              <div class="text-right mt-5">
                <v-btn
                  outlined
                  color="blue darken-1"
                  type="submit"
                  small
                  dark
                  rounded
                  depressed
                  :loading="loading"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Salvar
                </v-btn>
                <v-btn
                  class="ml-1"
                  color="red darken-2"
                  type="button"
                  outlined
                  small
                  dark
                  rounded
                  depressed
                  @click="show(false)"
                >
                  <v-icon left>mdi-close</v-icon>
                  Fechar
                </v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from '@/utils/rules'
import Papeis from '@/services/papeis'

export default {
  name: 'DialogNovoPapel',

  data() {
    return {
      dialog: false,
      loading: false,
      rules: rules,

      form: {
        nome: ''
      }
    }
  },

  methods: {
    async salvar() {
      if(!this.$refs.form.validate()) return

      try{
        this.loading = true
        await new Papeis().insert(this.form.nome)
        this.$swal.success('Salvo com sucesso!')
        this.$refs.form.reset()
        this.$emit('salvar')
      }catch(error){
        console.error(error)
        this.$toast.error(error)
      }finally{
        this.loading = false
      }
    },

    show(show = true) {
      this.dialog = show
      this.form.nome = ''
    }
  }
}
</script>
